import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  const { active = false } = props;
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.256 4.756a3.756 3.756 0 11-7.511 0 3.756 3.756 0 017.511 0zM11.5 9.837c1.017 0 1.965-.3 2.76-.816.879.335 1.694.831 2.403 1.467L11.5 12.424l-5.163-1.936A7.725 7.725 0 018.74 9.021a5.051 5.051 0 002.76.816zm7.954 4.861h-.442a.663.663 0 00-.663.663v1.767c0 .366.297.663.663.663h.442a1.546 1.546 0 100-3.093zM3.768 11.896a.663.663 0 01.895-.62l6.174 2.315v10.032l-6.64-2.49a.663.663 0 01-.43-.62v-1.397h.222a1.99 1.99 0 001.988-1.988V15.36a1.99 1.99 0 00-1.988-1.988h-.221v-1.476zm13.255 5.232V15.36a1.99 1.99 0 011.989-1.988h.22v-1.476a.663.663 0 00-.895-.62l-6.174 2.315v10.032l6.64-2.49a.663.663 0 00.43-.62v-1.397h-.221a1.99 1.99 0 01-1.989-1.988zM4.651 15.36v1.767a.663.663 0 01-.663.663h-.442a1.546 1.546 0 110-3.093h.442c.366 0 .663.297.663.663z"
        fill={active ? "#E40046" : "#777"}
        fillOpacity={0.8}
      />
    </Svg>
  );
}

export default SvgComponent;
